var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper nav-open"},[_c('side-bar',[_c('user-menu'),_c('mobile-menu'),(_vm.layoutType === 'classroom' && _vm.classroom_dashboard)?_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Classroom Dashboard',
          path: '/hilo/classroomDashboard',
          image: '/static/img/Classroom.svg',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Back to Home',
          path: '/hilo/homeScreen',
          image: '/static/img/Return.svg',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Curriculum',
          path: '/hilo/curriculumTemplates',
          image: '/static/img/Curriculum.svg',
        }}}),_c('br'),_vm._l((_vm.months),function(month){return _c('sidebar-item',{key:month.label,class:[month.classList.length === 0 ? 'disabled' : ''],attrs:{"link":{
          name: month.label + ' Class',
          path: '/hilo/classroomDashboard/month',
          image: '/static/img/letters/' + month.label[0] + '.svg',
          count: month.classList.length > 99 ? '+99' : month.classList.length,
        }}},_vm._l((month.classList),function(classObj){return _c('sidebar-item',{key:classObj.id,attrs:{"link":{
            name:
              classObj.curriculum.program.name +
              ' ' +
              classObj.activeInstructor.user.lastName,
            path:
              '/hilo/classroomDashboard/adminClassView/' +
              classObj.id +
              '?month=' +
              month.label +
              '&curriculumId=' +
              classObj.curriculumId,
            image: '/static/img/Book.svg',
          }}})}),1)}),_c('sidebar-item',{attrs:{"link":{
          name: 'Archive',
          path: '/hilo/classroomDashboard/archivedClasses',
          image: '/static/img/archive.svg',
        }}})],2):(_vm.layoutType === 'settings' && _vm.settings)?_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Back to Home',
          path: '/hilo/homeScreen',
          image: '/static/img/Return.svg',
        }}}),_c('br'),_c('sidebar-item',{attrs:{"link":{
          name: 'Users',
          path: '/settings/usersSettings',
          image: '/static/img/SettingsUsers.svg',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Permissions',
          path: '/settings/permissionSettings',
          image: '/static/img/LighLock.svg',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'General',
          path: '/settings/generalSettings',
          image: '/static/img/SettingsGear.svg',
        },"coming-soon":""}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Customization',
          path: '/settings/customizationSettings',
          image: '/static/img/SettingsSlider.svg',
        },"coming-soon":""}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Connections',
          path: '/settings/connectionSettings',
          image: '/static/img/SettingsConnect.svg',
        },"coming-soon":""}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Billing',
          path: '/settings/billingSettings',
          image: '/static/img/CreditCard.svg',
        },"coming-soon":""}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Security',
          path: '/settings/securitySettings',
          image: '/static/img/SettingsShield.svg',
        },"coming-soon":""}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Usage Stats',
          path: '/settings/usageSettings',
          image: '/static/img/Graph.svg',
        },"coming-soon":""}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Tidy Up',
          path: '/settings/tidyUpSettings',
          image: '/static/img/TidyUp.svg',
        },"coming-soon":""}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Content Directory',
          path: '/settings/contentDirectorySettings',
          image: '/static/img/ContentSettings.svg',
        },"coming-soon":""}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Apps',
          path: '/settings/appSettings',
          image: '/static/img/Puzzle.svg',
        },"coming-soon":""}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Cross Account Copier',
          path: '/settings/accountCopierSettings',
          image: '/static/img/Across.svg',
        },"coming-soon":""}})],1):_c('template',{slot:"links"},[(_vm.home)?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          path: '/hilo/homeScreen',
          image: '/static/img/Dashboard.svg',
        }}}):_vm._e(),(_vm.classroom_dashboard)?_c('sidebar-item',{attrs:{"link":{
          name: 'Classroom Dashboard',
          path: '/hilo/classroomDashboard',
          image: '/static/img/Classroom.svg',
        }}}):_vm._e(),(_vm.classroom_instructor)?_c('sidebar-item',{attrs:{"link":{
          name: 'Classroom Instructor',
          path: '/hilo/classroomInstructor',
          image: '/static/img/Classroom.svg',
        }}}):_vm._e(),(_vm.classroom_student)?_c('sidebar-item',{attrs:{"link":{
          name: 'Classroom',
          path: '/hilo/classroomStudent',
          image: '/static/img/Classroom.svg',
        }}}):_vm._e(),(_vm.classroom_student && _vm.singleStudentGradebook)?_c('sidebar-item',{attrs:{"link":{
          name: 'Grade Book',
          path: '/hilo/singleStudentGradeBook',
          image: '/static/img/letters/A.svg',
        }}}):(_vm.classroom_dashboard)?_c('sidebar-item',{attrs:{"link":{
          name: 'Grade Book',
          path: '/hilo/adminGradeBook',
          image: '/static/img/Student Male.svg',
        }}}):_vm._e(),(_vm.flight_schedule)?_c('sidebar-item',{attrs:{"link":{
          name: 'Schedule',
          path: '/hilo/schedule',
          image: '/static/img/Calendar.svg',
        }}}):_vm._e(),(_vm.curriculum)?_c('sidebar-item',{attrs:{"link":{
          name: 'Curriculum',
          path: '/hilo/curriculumTemplates',
          image: '/static/img/Curriculum.svg',
        }}}):_vm._e(),(_vm.hilo_assist)?_c('sidebar-item',{attrs:{"link":{
          name: 'Hilo Assist',
          path: '/hilo/hiloAI',
          image: '/static/img/Sparkling.svg',
        }}}):_vm._e(),(_vm.aircraft)?_c('sidebar-item',{attrs:{"link":{
          name: 'Aircraft',
          path: '/hilo/aircraft',
          image: '/static/img/Airport.svg',
        }}}):_vm._e(),(_vm.reservations)?_c('sidebar-item',{attrs:{"link":{
          name: 'Reservations',
          path: '/hilo/reservations',
          image: '/static/img/Bookmark.svg',
        }}}):_vm._e(),(_vm.lender_dashboard)?_c('sidebar-item',{attrs:{"link":{
          name: 'Lender Dashboard',
          path: '/hilo/lenderDashboard',
          image: '/static/img/Dashboard.svg',
        }}}):_vm._e(),(_vm.lender_dashboard)?_c('sidebar-item',{attrs:{"link":{
          name: 'Grade Book',
          path: '/hilo/lender/gradebook',
          image: '/static/img/Student Male.svg',
        }}}):_vm._e(),(_vm.logbook & !_vm.lender_dashboard)?_c('sidebar-item',{attrs:{"link":{
          name: 'Log Book',
          path: '/hilo/logbook',
          image: '/static/img/Book.svg',
        }}}):_vm._e(),(_vm.crm)?_c('sidebar-item',{attrs:{"link":{
          name: 'CRM',
          path: '/hilo/crm',
          image: '/static/img/CRM.svg',
        }}}):_vm._e(),(_vm.checkride_dropdown)?_c('sidebar-item',{attrs:{"name":"Checkride","link":{ name: 'Checkride', image: '/static/img/ContactDetails.svg' }}},[(_vm.checkride_schedule)?_c('sidebar-item',{attrs:{"link":{
            name: 'Schedule',
            path: '/hilo/checkrideSchedule',
            image: '/static/img/Calendar.svg',
          }}}):_vm._e(),(_vm.checkride_dpe_contact_info)?_c('sidebar-item',{attrs:{"link":{
            name: 'DPE Contact Info',
            path: '/hilo/dpeContactInfo',
            image: '/static/img/Bell.svg',
          }}}):_vm._e(),(_vm.checkride_dpe_contact_form)?_c('sidebar-item',{attrs:{"link":{
            name: 'DPE Contact Form',
            path: '/hilo/dpeContactForm',
            image: '/static/img/Bell.svg',
          },"coming-soon":""}}):_vm._e()],1):_vm._e(),(_vm.instructors)?_c('sidebar-item',{attrs:{"link":{
          name: 'Instructors',
          path: '/hilo/instructors',
          image: '/static/img/Student Male.svg',
        }}}):_vm._e(),(_vm.students)?_c('sidebar-item',{attrs:{"link":{
          name: 'Students',
          path: '/hilo/students',
          image: '/static/img/Student Male.svg',
        }}}):_vm._e(),(_vm.billing)?_c('sidebar-item',{attrs:{"link":{
          name: 'Billing',
          path: '/hilo/billing',
          image: '/static/img/Payroll.svg',
        },"coming-soon":""}}):_vm._e(),(_vm.chat)?_c('sidebar-item',{attrs:{"link":{
          name: 'Messages',
          path: '/hilo/chat',
          image: '/static/img/Chat.svg',
        },"coming-soon":""}}):_vm._e(),(_vm.task_manager)?_c('sidebar-item',{attrs:{"link":{
          name: 'Task Manager',
          path: '/hilo/taskManager',
          image: '/static/img/Realtime.svg',
        },"coming-soon":""}}):_vm._e(),(_vm.maintenance)?_c('sidebar-item',{attrs:{"link":{
          name: 'Maintenance',
          path: '/hilo/maintenance',
          image: '/static/img/Maintenance.svg',
        },"coming-soon":""}}):_vm._e(),(_vm.payroll)?_c('sidebar-item',{attrs:{"link":{
          name: 'Payroll',
          path: '/hilo/instructorPayroll',
          image: '/static/img/Payroll.svg',
        },"coming-soon":""}}):_vm._e(),(_vm.maps)?_c('sidebar-item',{attrs:{"link":{
          name: 'Maps',
          path: '/hilo/maps',
          image: '/static/img/Map.svg',
        },"coming-soon":""}}):_vm._e(),(_vm.weather)?_c('sidebar-item',{attrs:{"link":{
          name: 'Weather',
          path: '/hilo/maps', // need to create a new page
          image: '/static/img/Cloud.svg',
        },"coming-soon":""}}):_vm._e(),(_vm.reports)?_c('sidebar-item',{attrs:{"link":{
          name: 'Reports',
          path: '/hilo/reports',
          image: '/static/img/Connect.svg',
        },"coming-soon":""}}):_vm._e(),(_vm.masterclass)?_c('sidebar-item',{attrs:{"link":{
          name: 'Masterclass',
          path: '/hilo/masterclass',
          image: '/static/img/Connect.svg',
        },"coming-soon":""}}):_vm._e(),(_vm.hilo_admin_dashboard)?_c('sidebar-item',{attrs:{"link":{
          name: 'Hilo Admin Dashboard',
          path: '/hilo/hiloAdminDashboard',
          image: '/static/img/Dashboard.svg',
        }}}):_vm._e()],1)],2),_c('div',{ref:"mainPanel",staticClass:"main-panel"},[_c('top-navbar'),_c('notifications'),_c('div',{staticClass:"scrollable-content"},[_c('dashboard-content')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }